/// FOURJS_START_COPYRIGHT(D,2016)
/// Property of Four Js*
/// (c) Copyright Four Js 2016, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum(
  "FrontCallService.modules.qa",
  ["FrontCallService"],

  // This module is just a placeholder for clientqa wrong way of doing
  // (injecting his own JS here instead of asking for GBC controlled implementation)...

  function (context, cls) {
    context.FrontCallService.modules.qa = {
      startqa: function () {
        return [""];
      }
    };
  }
);
